export const ROLES = {
  ADMIN: "admin",
  AUDITOR: "auditor",
  USER: "user",
};

export const PERMISSIONS = {
  VIEW_ALL_REFERRALS: "VIEW_ALL_REFERRALS",
  CREATE_REFERRAL: "CREATE_REFERRAL",
  CHANGE_REFERRAL: "CHANGE_REFERRAL",
  REMOVE_REFERRER: "REMOVE_REFERRER",
  VIEW_ALL_REFERRAL_CODES: "VIEW_ALL_REFERRAL_CODES",
  VIEW_PAYMENT_FILE: "VIEW_PAYMENT_FILE",
  VIEW_ADMIN_PROFILE: "VIEW_ADMIN_PROFILE",
  IMPERSONATE_USER: "IMPERSONATE_USER",
};

export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.VIEW_ALL_REFERRALS,
    PERMISSIONS.CREATE_REFERRAL,
    PERMISSIONS.CHANGE_REFERRAL,
    PERMISSIONS.REMOVE_REFERRER,
    PERMISSIONS.VIEW_ALL_REFERRAL_CODES,
    PERMISSIONS.VIEW_PAYMENT_FILE,
    PERMISSIONS.VIEW_ADMIN_PROFILE,
    PERMISSIONS.IMPERSONATE_USER,
  ],
  [ROLES.AUDITOR]: [
    PERMISSIONS.VIEW_ALL_REFERRALS,
    PERMISSIONS.VIEW_ALL_REFERRAL_CODES,
    PERMISSIONS.VIEW_ADMIN_PROFILE,
  ],
  [ROLES.USER]: [],
};

export const ROLE_LABELS = {
  [ROLES.ADMIN]: "Admin",
  [ROLES.AUDITOR]: "Auditor",
};

export const hasPermission = (role, permission) => {
  const permissions = ROLE_PERMISSIONS[role];
  if (!permissions) return false;
  return permissions.includes(permission);
};

export const getRoleLabel = (role) => {
  return ROLE_LABELS[role] || "";
};
